<template>
  <section class="about-us" style="margin-bottom: 5rem; margin-top: 12rem;">
    <div class="container">
      <div class="sub-title color-dark">About Global Vision</div>
      <div class="section-title color-dark">ABOUT US</div>
      <div class="para color-dark">
        Global Vision or widely known as GVC is a reputable full-service business development and educational
        consultancy company providing result-driven strategies that tailor fits businesses to the next level. With years
        of experience in the industry and being the arm of the Ministry of Education, our company is spearheading
        hundreds of businesses, B2B collaborations as well as professional and/or educational training across the
        country. Our company ensures a high quality of service and commitment from our esteemed experts which holds more
        than 10 years of experience in a wide range of expertise. We believe that through education, we can change the
        world and can move forward for a better society. Our mission is to improve the educational system in the UAE and
        make it one of the most leading pioneer systems in the world through supporting our partners and clients with
        all the tools possible to succeed in their mission and enhance their professionalism and profitability through
        effective representation of their branding and events.
      </div>
      <div class="para color-dark">
        Global Vision Group is a strategic partner that can deliver a wide range of services related to Training &
        Professional Development, education business consultation, Media planning and buying, and events management. Our
        clients benefit from our bespoke services that are tailored to each customer’s needs. Such services include but
        not limited to outsourcing and/or recruitment of highly regarded professionals, skills development, corporate
        training, smart camps, E-learning, business development, B2B collaborations and so much more.
      </div>
      <div class="para color-dark">
        What makes us unique in the market is our competitive quality and what we have to offer. Want to learn more
        about us? Let’s move forward together.
      </div>
    </div>
  </section>

  <section class="ceo">
    <div class="container-fluid">
      <div class="row p-5">
        <div class="sub-title color-light">Meet Our CEO</div>
        <div class="section-title color-light">Mr. Hany Asaad</div>
        <div class="col-xl-6 mb-5">
          <img
              src="../assets/images/aboutus/background-ceo.png"
              class="img-fluid"
              alt="ceo"
          />
        </div>
        <div class="col-xl-6">
          <div class="para color-light">
            Hany Asaad is an Educational Consultant and a Goodwill Ambassador with over 25 years of experience in
            Training and Gifted Talents Education. He is the CEO and Founder of Global Vision Group that owns Global
            Vision Educational Consultancy, Global Vision Events Management, Global Vision Art Academy, Global Vision
            Music Academy, House of Heritage, Global Vision Cares- Hands Together Egypt and collaborates with
            international companies such as Mathnasium, Kuder USA and Cathachain.
          </div>
          <div class="para color-light">
            Hany Asaad oversees the strategic direction of the company in helping to pioneer the business development,
            B2B collaborations and Training and Educational industry across UAE. With very strong analytical skills and
            problem-solving abilities, Hany is a premier and fully-integrated provider of smart technology solutions in
            handling innovative projects, corporate events and even customer relationship management. With strong
            international exposure, having travelled to different parts of the globe, he can provide full support to his
            partners at any time and anywhere.
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="company-history">
    <div class="container">
      <div class="section-title color-dark col-lg-8">
        COMPANY’S HISTORY AND THE CEO’S ACHIEVEMENT
      </div>
      <div class="row">
        <div class="col-xl-6 order-2">
          <div class="para color-dark">
            Equipped with broadened experience and extensive business know-how, Hany started to have a clear and bold
            vision of the future. Inspired by his childhood and experience, he understood the problems and changes in
            this modern society, and he believes that through education, we can all move forward to a better society.
          </div>
          <div class="para color-dark">
            In 2015, he established Global Vision Training and Education Consultancy LLC, intending to bring a full set
            of competencies of education and technology. His aspirations were prominent which made him successfully
            merge with the leading educational stakeholders in the UAE, such as The Ministry of Education and ALEF
            Education to name a few.
          </div>
          <div class="para color-dark">
            As his ideas grew in the UAE, he felt the social responsibility in giving the opportunity of education to
            those in need. From there he founded a non-profit organization, Hands Together Foundation in Egypt in 2016.
            He believed that this organization will transform the lives of the people affected by the compressions of
            society through education and innovative activities, to contribute to the region’s successful landscape.
          </div>
          <div class="para color-dark">
            In 2018, Hany Asaad started Global Vision Event Management, in line with his educational path, GVE tends to
            elevate educational events to a different level and differentiate the company to the rest through providing
            its partners with the right set of capabilities and adapt to the evolving needs and wants of today’s
            society. In 2020, GVE expanded to deliver a wider range of services from virtual and experiential events and
            web development to sport events and pop-up environments.
          </div>
        </div>
        <div class="col-xl-6 order-1 mb-5">
          <div class="d-flex align-items-center justify-content-center">
            <img
                alt="company-history"
                class="img-company-history img-fluid"
                src="../assets/images/aboutus/company-history.png"
            />
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="hany">
    <div class="container-fluid">
      <div class="row p-5">
        <div class="col-xl-4 col-lg-12 img-container mb-5">
          <img
              alt="hany"
              class="img-fluid hany-img"
              src="../assets/images/aboutus/hany.png"
          />
        </div>
        <div class="col-xl-8 col-lg-12">
          <div class="para color-light" style="line-height: 20px;">
            On his journey to success, Hany Asaad became an inspiration to
            many people, most importantly because of his selfless deeds and
            passion to wholesome society.
          </div>
          <div class="para color-light" style="line-height: 20px;">
            He understood the great value of listening, nurturing teamwork,
            delegating and people-orientation culture.
          </div>
          <div class="para color-light fw-bold" style="line-height: 20px;">
            “I don’t believe in the word employee. My achievements are built
            from the success of my team” - Hany Asaad
          </div>
          <div class="para color-light" style="line-height: 20px;">
            Hany Asaad continues to spread his ambitious ideas to promote
            positive change, along with his team and his strong leadership. He
            is committed to seeing strong growth and a better future through
            education and innovation on a global scale.
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="success-stories">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-6 section-card">
          <div
              class="
                d-flex
                align-items-center
                justify-content-center
                h-100
                w-100
              "
          >
            <div class="section-title color-dark mb-0">
              OUR SUCCESSFUL STORIES
            </div>
          </div>
        </div>
        <div class="col-lg-3 p-0">
          <div class="success-card">
            <img
                class="success-card-img img-fluid"
                alt="success-img"
                src="../assets/images/aboutus/A.png"
            />
            <div class="card-inner">
              <div class="success-card-text color-light">ALEF EDUCATION</div>
              <div class="success-card-text color-light">
                  <span>
                    <img alt="line" src="../assets/images/aboutus/card-line.png"/>
                  </span>
                2018 - 2020
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-3 p-0">
          <div class="success-card">
            <img
                class="success-card-img img-fluid"
                alt="success-img"
                src="../assets/images/aboutus/B.png"
            />
            <div class="card-inner">
              <div class="success-card-text color-light">SCOUT CAMPS</div>
              <div class="success-card-text color-light">
                  <span>
                    <img alt="line" src="../assets/images/aboutus/card-line.png"/>
                  </span>
                2018 - 2020
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-3 p-0">
          <div class="success-card">
            <img
                class="success-card-img img-fluid"
                alt="success-img"
                src="../assets/images/aboutus/C.png"
            />
            <div class="card-inner">
              <div class="success-card-text color-light">AIR SERIES</div>
              <div class="success-card-text color-light">
                  <span>
                    <img alt="line" src="../assets/images/aboutus/card-line.png"/>
                  </span>
                2019 - 2021
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-3 p-0">
          <div class="success-card">
            <img
                class="success-card-img img-fluid"
                alt="success-img"
                src="../assets/images/aboutus/D.png"
            />
            <div class="card-inner">
              <div class="success-card-text color-light">TDRA INNOVATION CAMPS</div>
              <div class="success-card-text color-light">
                  <span>
                    <img alt="line" src="../assets/images/aboutus/card-line.png"/>
                  </span>
                2018 - 2021
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-3 p-0">
          <div class="success-card">
            <img
                class="success-card-img img-fluid"
                alt="success-img"
                src="../assets/images/aboutus/E.png"
            />
            <div class="card-inner">
              <div class="success-card-text color-light">
                SERIES OF GVC SMART CAMP
              </div>
              <div class="success-card-text color-light">
                  <span>
                    <img alt="line" src="../assets/images/aboutus/card-line.png"/>
                  </span>
                2018 - 2020
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-3 p-0">
          <div class="success-card">
            <img
                class="success-card-img img-fluid"
                alt="success-img"
                src="../assets/images/aboutus/F.png"
            />
            <div class="card-inner">
              <div class="success-card-text color-light">EMIRATES SKILLS</div>
              <div class="success-card-text color-light">
                  <span>
                    <img alt="line" src="../assets/images/aboutus/card-line.png"/>
                  </span>
                2018 - 2022
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-3 p-0">
          <div class="success-card">
            <img
                class="success-card-img img-fluid"
                alt="success-img"
                src="../assets/images/aboutus/G.png"
            />
            <div class="card-inner">
              <div class="success-card-text color-light">
                WORLDSKILLS
              </div>
              <div class="success-card-text color-light">
                  <span>
                    <img alt="line" src="../assets/images/aboutus/card-line.png"/>
                  </span>
                2018 - 2019
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-3 p-0">
          <div class="success-card">
            <img
                class="success-card-img img-fluid"
                alt="success-img"
                src="../assets/images/aboutus/H.png"
            />
            <div class="card-inner">
              <div class="success-card-text color-light">ROBOCUP</div>
              <div class="success-card-text color-light">
                  <span>
                    <img alt="line" src="../assets/images/aboutus/card-line.png"/>
                  </span>
                2018 - 2022
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="team">
    <div class="container">
      <div class="section-title color-light">GV TEAM</div>
      <div class="para color-light">
        Supported by our team of experts, our head office in Abu Dhabi has
        developed a multi-diversified portfolio with government,
        semi-government and private entities across the UAE by fulfilling the
        needs of our clients and partners.
      </div>
      <div class="para color-light">
        With every project we are constantly trying to outdo ourselves and go
        above and beyond to ensure the satisfaction of our partners. We are
        not afraid to push boundaries and provide new and unique ideas.
      </div>
      <div class="para color-light fw-bold">
        Expertise and a network of partners at the service of your project!
      </div>
      <div class="row mt-5" style="margin-left: 1rem; margin-right: 1rem;">
        <div class="col-xl-3">
          <div class="member">
            <img
                alt="member"
                class="member member-width"
                src="../assets/images/aboutus/member1.png"
            />
            <div class="para color-light mb-0">Hany Asaad</div>
            <div class="member-position color-light">CEO</div>
          </div>
        </div>
        <div class="col-xl-3">
          <div class="member">
            <img
                alt="member"
                class="member member-width"
                src="../assets/images/aboutus/member2.png"
            />
            <div class="para color-light mb-0">Lamia Khairy</div>
            <div class="member-position color-light">Project Manager</div>
          </div>
        </div>
        <div class="col-xl-3">
          <div class="member">
            <img
                alt="member"
                class="member member-width"
                src="../assets/images/aboutus/member3.png"
            />
            <div class="para color-light mb-0">Azza Khair Elseed</div>
            <div class="member-position color-light">
              Creative Projcet Manager
            </div>
          </div>
        </div>
        <div class="col-xl-3">
          <div class="member">
            <img
                alt="member"
                class="member member-width"
                src="../assets/images/aboutus/member4.png"
            />
            <div class="para color-light mb-0">Omar Debsi</div>
            <div class="member-position color-light">Head Of Technology</div>
          </div>
        </div>
        <div class="col-xl-3">
          <div class="member">
            <img
                alt="member"
                class="member member-width"
                src="../assets/images/aboutus/member5.png"
            />
            <div class="para color-light mb-0">Markos Amin</div>
            <div class="member-position color-light">Finance Manager</div>
          </div>
        </div>
        <div class="col-xl-3">
          <div class="member">
            <img
                alt="member"
                class="member member-width"
                src="../assets/images/aboutus/member6.png"
            />
            <div class="para color-light mb-0">Nessem Beshara</div>
            <div class="member-position color-light">Purchasing Manager</div>
          </div>
        </div>
        <div class="col-xl-3">
          <div class="member">
            <img
                alt="member"
                class="member member-width"
                src="../assets/images/aboutus/member7.png"
            />
            <div class="para color-light mb-0">Marianne O. Aromin</div>
            <div class="member-position color-light">HR Manager</div>
          </div>
        </div>
        <div class="col-xl-3">
          <div class="member">
            <img
                alt="member"
                class="member member-width"
                src="../assets/images/aboutus/member8.png"
            />
            <div class="para color-light mb-0">Mahmoud Jebri</div>
            <div class="member-position color-light">IT Project Manager</div>
          </div>
        </div>
        <div class="col-xl-3">
          <div class="member">
            <img
                alt="member"
                class="member member-width"
                src="../assets/images/aboutus/member9.png"
            />
            <div class="para color-light mb-0">Hamza Jeyms</div>
            <div class="member-position color-light">
              Senior Graphic Designer
            </div>
          </div>
        </div>
        <div class="col-xl-3">
          <div class="member">
            <img
                alt="member"
                class="member member-width"
                src="../assets/images/aboutus/member10.png"
            />
            <div class="para color-light mb-0">Ma. Gracia Ella Padua</div>
            <div class="member-position color-light">Admin</div>
          </div>
        </div>
        <div class="col-xl-3">
          <div class="member">
            <img
                alt="member"
                class="member member-width"
                src="../assets/images/aboutus/member11.png"
            />
            <div class="para color-light mb-0">Alexandra L. Remonde</div>
            <div class="member-position color-light">Music Teacher</div>
          </div>
        </div>
        <div class="col-xl-3">
          <div class="member">
            <img
                alt="member"
                class="member member-width"
                src="../assets/images/aboutus/member12.png"
            />
            <div class="para color-light mb-0">Sheila M. Alegre</div>
            <div class="member-position color-light">Centre Director</div>
          </div>
        </div>
      </div>
    </div>
    <img alt="logo" src="../assets/images/aboutus/logo-deco.png" class="logo-deco"/>
  </section>
</template>

<script>
export default {
  name: 'AboutUs',
}
</script>

<style scoped>
@import '../assets/styles/aboutus.css';

@media (min-width: 1200px) and (max-width: 1500px) {
  .success-card-text {
    font-size: 15px;
  }
}

@media (min-width: 1500px) and (max-width: 1676px) {
  .success-card-text {
    font-size: 20px;
  }
}
</style>
